import React, { useState, useEffect } from "react";
import {useNavigate, Link, useLocation} from "react-router-dom";
import './Login.css';
import 'font-awesome/css/font-awesome.min.css';
import { useAuth } from '../../auth/AuthContext';

function Login() {
    const [email, setEmail] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { user, signIn } = useAuth();
    const from = location.state?.from?.pathname || location.state?.from || '/dashboard';

    useEffect(() => {
        if (user) navigate(from, { replace: true });
    }, [user, navigate, from])

    const handleLogin = async (e) => {
        e.preventDefault();
        const password = e.target.password.value;

        try {
            await signIn(email.toLowerCase().trim(), password);
        } catch (err) {
            if (err?.response?.data?.message) setError(err.response.data.message);
            else setError("Usuario o contraseña incorrectos.");
        }
    };

    return (
        <div className="login-page-wrapper">
            <div className="login-card">

                <div className="login-header">
                    <h1>Bienvenida</h1>
                </div>

                {error && (
                    <div className="error-banner">
                        <i className="fa fa-exclamation-circle"></i>
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleLogin} className="login-form">
                    <div className="form-group">
                        <input
                            type="text"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Usuario o Email"
                            required
                            autoCapitalize="none"
                            inputMode="email"
                        />
                    </div>

                    <div className="form-group password-wrapper">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            placeholder="Contraseña"
                            required
                        />
                        <button
                            type="button"
                            className="toggle-password"
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label="Mostrar contraseña"
                        >
                            <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                        </button>
                    </div>

                    <button type="submit" className="login-button">
                        Iniciar Sesión
                    </button>
                </form>

                <div className="auth-footer">
                    <Link to="/forgot-password" className="auth-link">
                        ¿Has olvidado tu contraseña?
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Login;